<template>
  <div class="main contact">
    <h1 class="page-title">Contact</h1>
    <div>
      <img src="@/assets/images/headshot.png" alt="illustrated headshot" />
      <div class="contact-text">
        <p class="discuss">
          To discuss a project or opportunity please contact:
        </p>
        <p class="name">Anastasia Laczko</p>
        <div class="contact-list">
          <li>
            <i class="fa fa-map-marker fa-fw mini-icon" aria-hidden="true"></i
            >San Francisco, California, US<br />
          </li>
          <li>
            <i class="fa fa-envelope fa-fw mini-icon" aria-hidden="true"></i
            >anastasia.laczko@gmail.com
          </li>
        </div>
        <a
          v-for="link in links"
          v-bind:key="link.name"
          :href="link.url"
          target="_blank"
        >
          <i :class="`icon fab ${link.name} ${link.icon}`"></i>
        </a>
        <p class="footer">@2021 Website designed & built by Anastasia Laczko</p>
      </div>
    </div>
  </div>
</template>

<script>
import { links } from "@/data/contactLinks.js";
export default {
  name: "Contact",
  data() {
    return {
      links: links
    };
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/_media_sizes.scss";
@import "@/assets/_colours.scss";
@import "@/assets/_font.scss";

.contact {
  & > div {
    display: flex;

    img {
      background: $accent-dull-blue;
      max-height: 250px;
      max-width: 250px;
      border-radius: 100%;
    }

    .contact-text {
      .discuss {
        margin-bottom: 1.5em;
      }

      .name {
        font-size: $font-M;
        font-weight: 600;
        font-family: "Roboto", sans-serif;
      }

      p {
        font-size: $font-S;
      }

      .contact-list {
        margin-bottom: 2em;

        li {
          margin: 0.5em 0;
          list-style: none;
        }
      }

      .icon {
        font-size: 50px;
        margin: 0 10px 0 10px;
        transition-duration: 0.3s;

        &:hover {
          cursor: pointer;
        }
      }

      .linkedin-logo {
        color: #6a9cc9;
        margin-left: 0;

        &:hover {
          color: #07679b;
        }
      }

      .github-logo {
        color: #a569a5;

        &:hover {
          color: #590059;
        }
      }

      .medium-logo {
        color: $light-grey;

        &:hover {
          color: $dark-grey;
        }
      }

      .footer {
        font-size: $font-XS;
        margin-top: 30px;
        color: $text-grey;
        font-style: italic;
      }
    }
  }
}

@media only screen and (min-width: $phone-S) {
  .contact {
    img {
      height: auto;
      width: 80%;
    }

    & > div {
      flex-direction: column;
      align-items: center;

      .contact-text {
        margin: 20px 0;
      }
    }
  }
}

@media only screen and (min-width: $phone-L) {
  //to fill
}

@media only screen and (min-width: $tablet-potrait) {
  .contact {
    & > div {
      flex-direction: row;
      align-items: flex-start;
      justify-content: center;
      margin-bottom: 50px;
      .contact-text {
        margin: 0 50px;
      }
    }
  }
}
</style>
